/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const EmailRequest = zod
	.object({
		email: zod.email().describe('Email address')
	})
	.describe('Email request body');

export type EmailRequest = zod.input<typeof EmailRequest>;
export type EmailRequestOutput = zod.output<typeof EmailRequest>;
